import warning, { resetWarned } from "rc-util/es/warning";
export { resetWarned };
export default (function (valid, component, message) {
  warning(valid, "[antd: ".concat(component, "] ").concat(message));
});
//# sourceMappingURL=warning.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/warning.js
// module id = ./node_modules/antd/es/_util/warning.js
// module chunks = 86